import * as Optional from "optional-js";

import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import i18n from 'l10n';

export default Backbone.Model.extend({
    initialize: function (options) {
        if (_.difference(_.keys(options), ["type", "kind", "name", "customFieldType"]).length > 0) return;
        const optionalOptions = Optional.ofNullable(options);
        let type = optionalOptions.map(o => o.type).orElse(null);
        const kind = optionalOptions.map(o => o.kind);
        const customFieldType = optionalOptions.map(o => o.customFieldType).orElse(null);
        const isLogo = type.indexOf("Logo") > -1;
        if (isLogo) type = type.replace("Logo", "");
        const required = kind.isPresent();
        const textQuestion = kind.filter(k => k.includes("cf"))
            .map(() => options.name)
            .or(() => kind.filter(k => k !== "").map(k => i18n.t(`subscriber.${k}`)))
            .orElse("");
        this.set("type", type);
        switch (type) {
            case "SurveyFreeText":
                this.set("title", i18n.t(""));
                this.set("textQuestion", textQuestion);
                this.set("kind", kind.orElse(null));
                this.set("required", required);
                if (this.get("kind") === "firstname") {
                    this.set("numberOfCharacters", 20);
                } else if (this.get("kind") === "lastname") {
                    this.set("numberOfCharacters", 35);
                } else if (this.get("kind") === "address") {
                    this.set("numberOfCharacters", 125);
                } else if (this.get("kind") === "profession") {
                    this.set("numberOfCharacters", 45);
                } else {
                    this.set("numberOfCharacters", 512);
                }
                break;
            case "SurveyDate":
                this.set("title", i18n.t(""));
                this.set("textQuestion", textQuestion);
                this.set("date", null);
                this.set("kind", kind.orElse(null));
                this.set("required", true);
                break;
            case "SurveyStarRating":
                this.set("title", i18n.t(""));
                this.set("required", false);
                this.set("size", 5);
                break;
            case "SurveyImage":
                this.set("title", i18n.t(""));
                this.set("imageId", "");
                this.set("logo", isLogo);
                break;
            case "SurveyFormattedText":
                this.set("titleText", i18n.t(""));
                this.set("mainText", "");
                this.set("footerText", "");
                break;
            case "SurveySocialShare":
                this.set("title", i18n.t("survey.shareThis"));
                this.set("buttons", [
                    {network: "FACEBOOK", active: true},
                    {network: "TWITTER", active: true},
                    {network: "GPLUS", active: true}
                ]);
                break;
            case "SurveySocialFollow":
                this.set("title", i18n.t("survey.followUs"));
                this.set("buttons", [
                    {network: "FACEBOOK", url: null},
                    {network: "TWITTER", url: null},
                    {network: "GPLUS", url: null}
                ]);
                break;
            case "CustomFieldComponent":
                this.set("title", i18n.t(""));
                this.set("textQuestion", textQuestion);
                this.set("kind", kind.orElse(null));
                this.set("required", required);
                this.set("numberOfCharacters", 60);
                this.set("customFieldType", customFieldType);
                // if (customFieldType === "multipleChoice") {
                //     this.set("choices", ["", "", "", ""]);
                // }
                break;
            case "CustomFieldMultipleChoiceComponent":
                this.set("title", i18n.t(""));
                this.set("textQuestion", textQuestion);
                this.set("kind", kind.orElse(null));
                this.set("required", required);
                this.set("customFieldType", customFieldType);
                this.set("choices", ["", "", "", ""]);
                break;
            case "PayPalButton" :
                this.set("price", i18n.t(""));
                this.set("itemName", i18n.t(""));
                this.set("kind", "payPalButton");
                break;
            default:
                this.set("title", i18n.t(""));
                this.set("textQuestion", i18n.t(""));
                this.set("required", false);
                this.set("multiple", false);
                this.set("choices", ["", "", "", ""]);
        }
    },
    setArray: function (prop, index, str) {
        this.get(prop)[index] = str;
        this.changed[`${prop}[${index}]`] = str;
        this.trigger('change', this);
    }
});
